
import { useEffect, useState } from "react"
import url from "../api/url"
import { useEmpleadoStore } from "../stores/useEmpleadoStore"
import { elToast } from "../functions/Alerta"

const useEscolaridades = () => {

    // variables
    const setToast = useEmpleadoStore( state => state.setToast )
    const objLogueado = useEmpleadoStore(state => state.objLogueado)
    const [openEditar, setOpenEditar] = useState(false)
    const [mostrarInput, setMostrarInput] = useState(true)
    const [mostrarOcultar, setMostrarOcultar] = useState(false)
    const escolaridadInicial = {
        funcion: 'guardarEscolaridad',
        carrera: '',
        escolaridad: 'Seleccione una opción',
        institucion: '',
        cedula: '',
        titulado: false,
        archivo_cedula: '',
        archivo_titulo: '',
        extension_cedula: '',
        extension_titulo: '',
        correo: objLogueado.email
    }
    const { URL, SERVIDOR } = url()
    const [isOpen, setIsOpen] = useState( false )
    const [escolaridadesUsuario, setEscolaridadesUsuario] = useState([])
    const [formEscolaridad, setFormEscolaridad] = useState( escolaridadInicial )
    const [pk_escolaridad, setPk_escolaridad] = useState( 0 )
    const [cargando, setCargando] = useState( false )
    const [cargandoCedula, setCargandoCedula] = useState(false)
    const [cargandoTitulo, setCargandoTitulo] = useState(false)

    // variables para el modal editar
    const [isOpenEditar, setIsOpenEditar] = useState(false)
    const [campoEditando, setCampoEditando] = useState('')
    const [valorEditando, setValorEditando] = useState('')
    const [formModal, setFormModal] = useState({})
    const [formModal2, setFormModal2] = useState({})
    const [cargandoActualizar, setCargandoActualizar] = useState(false)
    const [nombreTitulo, setNombreTitulo] = useState('')
    const [nombreCedula, setNombreCedula] = useState('')
    const [cargandoCedulaEnlace, setCargandoCedulaEnlace] = useState(false)
    const [cargandoTituloEnlace, setCargandoTituloEnlace] = useState(false)

    // funciones
    const traerEscolaridad = () => {

        var fd = new FormData()
        fd.append("funcion", "traerEscolaridad")
        fd.append("correo", objLogueado.email)

        fetch( URL, {
            method: 'post',
            body: fd
        })
        .then( res => res.json() )
        .then( e => {
            setEscolaridadesUsuario( e )
        })
        .catch( a => {
            setToast( true )
        })

    }


    const guardarEscolaridad = () => {

        var perro = { ...formEscolaridad, pk_escolaridad }

        setCargando( true )
        fetch( URL, {
            method: 'post',
            // headers: {'Content-type': 'application/json'},
            body: JSON.stringify(perro)
        })
        .then( res => res.json() )
        .then( function (d) {
            // alert( d.mensaje )
            // eslint-disable-next-line
            if ( d.codigo == 1 ) {
                traerEscolaridad()
                setFormEscolaridad( escolaridadInicial )
                elToast( d.mensaje )
                cerrarModal()
            } else {
                elToast( d.mensaje, 'error' )
            }
        })
        .catch( a => alert("Error al guardar información.\nPuedes revisar tu conexión o iniciar sesión nuevamente.") )
        .finally( () => setCargando( false ) )
    }

    const abrirModal = ( borrar = true ) => {
        setIsOpen( true )
        if ( borrar ) {
            // agregar
            setMostrarInput(true)
            setPk_escolaridad( 0 )
        }
    }

    const cerrarModal = () => {
        setIsOpen( false )
        setFormEscolaridad( escolaridadInicial )
        setMostrarOcultar(false)
    }

    const cerrarModalEditar = () => {
        var perra = {
            funcion: '',
            carrera: '',
            cedula: '',
            escolaridad: '',
            escuela: '',
            titulado: '',
            correo: '',
            archivo_cedula: '',
            archivo_titulo: '',
        }
        setIsOpenEditar( false )
        setFormEscolaridad( escolaridadInicial )
        setPk_escolaridad(0)
        setCampoEditando('')
        setValorEditando('')
        setFormModal(perra)
        setFormModal2(perra)
        traerEscolaridad()
        setCargandoTituloEnlace(false)
        setCargandoCedulaEnlace(false)
    }

    const check = e => {
        setFormEscolaridad({
            ...formEscolaridad,
            titulado: e.target.checked,
            cedula: '',
            archivo_cedula: '',
            archivo_titulo: '',
            extension_cedula: '',
            extension_titulo: '',
        })
    }

    function borrarEscolaridad( pk_escolaridad, archivo_cedula, archivo_titulo ) {
        if ( pk_escolaridad && window.confirm("La escolaridad será eliminada.") ) {

            var correo_nuevo = objLogueado.email.split('@')[0];
            var objeto = {
                pk_escolaridad,
                funcion: 'borrarEscolaridad',
                correo: correo_nuevo,
                archivo_cedula,
                archivo_titulo
            }

            fetch( URL, {
                method: 'post',
                body: JSON.stringify(objeto)
            })
            .then( res => res.json() )
            .then( function (d) {
                traerEscolaridad()
                // alert( d.mensaje )
                // eslint-disable-next-line
                if ( d.codigo == 1 ) {
                    elToast( d.mensaje )
                } else {
                    elToast( d.mensaje, 'error' )
                }
            })
            .catch( a => alert("Error al eliminar información.\nPuedes revisar tu conexión o iniciar sesión nuevamente.") )
        }
    }

    function llenarFormEscolaridad( e ) {

        var perro = {
            funcion: 'actualizarEscolaridad',
            carrera: e.carrera,
            cedula: e.cedula,
            escolaridad: e.escolaridad,
            escuela: e.escuela,
            titulado: e.es_titulado,
            correo: objLogueado.email,
            archivo_cedula: e.archivo_cedula,
            archivo_titulo: e.archivo_titulo,
        }
        setFormModal( perro )
        setFormModal2( perro )
        setMostrarInput( e.archivo_cedula ? false : true )
        setPk_escolaridad( e.pk_escolaridad )
        // abrirModal( false )
        setIsOpenEditar(true)
        setNombreCedula( e.archivo_cedula )
        setNombreTitulo( e.archivo_titulo )
    }

    function procesarArchivo( e, tipo ) {

        if (e.target.value !== "") {

            var archivo = e.target.files[0]
            const extension = archivo.name.split('.').pop().toLowerCase();
            const extensionesPermitidas = ['jpg', 'jpeg', 'png', 'pdf'];


            if (extensionesPermitidas.includes(extension)) {

                let reader = new FileReader()
                reader.readAsDataURL(archivo)
                reader.onload = (f) => {

                    var a

                    if ( tipo === 'cedula' ) {
                        a = {
                            extension_cedula: extension,
                            archivo_cedula: f.target.result
                        }
                    } else {
                        a = {
                            extension_titulo: extension,
                            archivo_titulo: f.target.result
                        }
                    }



                    setFormEscolaridad({
                        ...formEscolaridad,
                        ...a
                    })

                    // eslint-disable-next-line
                    if ( formEscolaridad.funcion == 'actualizarEscolaridad' ) {
                        actualizarImagen(extension, f.target.result, pk_escolaridad, formEscolaridad.correo, formEscolaridad.escolaridad )
                    }

                }
            } else {
                alert( "Solo se admiten archivos en formato PDF o imágenes (jpg, jpeg, png)" )
                e.target.value = ""
            }
        } else {
            // Sin archivo
        }
    }

    function url_archivos(nombre_archivos) {

        var correo_nuevo = objLogueado.email.split('@')[0];

        return `${SERVIDOR}/archivos/${correo_nuevo}/${nombre_archivos}`

    }

    function actualizarUnSoloCampo(campo, valor, id) {
        // return

        if (campo === 'cedula') {
            // :D
        } else {
            if ( campo?.length === 0 || valor?.length === 0
                || campo === undefined || campo === null || valor === null || valor === undefined) {
                return
            }
        }

        // eslint-disable-next-line
        if ( formModal.archivo_cedula != formModal2.archivo_cedula ) {
            setFormModal2({
                ...formModal2,
                archivo_cedula: formModal.archivo_cedula
            })
            return
        }

        // eslint-disable-next-line
        if ( formModal.archivo_titulo != formModal2.archivo_titulo ) {
            setFormModal2({
                ...formModal2,
                archivo_titulo: formModal.archivo_titulo
            })
            return
        }

        setCargandoActualizar(true)
        let d_campo = {
            campo, valor, id,
            funcion: 'actualizarUnSoloCampo'
        }

        fetch( URL, {
            method: 'post',
            body: JSON.stringify(d_campo)
        })
        .then( res => res.json() )
        .then( function (d) {
            traerEscolaridad()
            // alert( d.mensaje )
            // eslint-disable-next-line
            if ( d.codigo == 1 ) {
                setFormEscolaridad( escolaridadInicial )
                elToast( d.mensaje )
                // cerrarModalEditar()
            } else {
                elToast( d.mensaje, 'error' )
            }
        })
        .catch( a => elToast("Error al guardar información.\nPuedes revisar tu conexión o iniciar sesión nuevamente.", 'error') )
        .finally( () => setCargandoActualizar( false ) )
    }

    function preguntarTitulacion(is_check) {

        setFormModal({
            ...formModal,
            titulado: is_check
        })
        setCampoEditando( 'es_titulado' )
        setValorEditando( is_check ? 'check' : 'no_check' )

    }

    function procesarArchivoEditar( e, tipo ) {

        if (e.target.value !== "") {

            var archivo = e.target.files[0]
            const extension = archivo.name.split('.').pop().toLowerCase();
            const extensionesPermitidas = ['jpg', 'jpeg', 'png', 'pdf'];


            if (extensionesPermitidas.includes(extension)) {

                let reader = new FileReader()
                reader.readAsDataURL(archivo)
                reader.onload = (f) => {
                    actualizarImagen(extension, f.target.result, pk_escolaridad, objLogueado.email, formModal.escolaridad, tipo )
                }
            } else {
                alert( "Solo se admiten archivos en formato PDF o imágenes (jpg, jpeg, png)" )
                e.target.value = ""
            }
        } else {
        }
    }

    function actualizarImagen(extension, archivo, pk_escolaridad, correo, escolaridad, tipo) {

        let d_imagen = {
            extension, archivo, pk_escolaridad, correo, escolaridad, tipo,
            funcion: 'actualizarSoloCedula'
        }

        if (tipo === 'cedula') {
            setCargandoCedula(true)
        } else {
            setCargandoTitulo(true)
        }
        fetch( URL, {
            method: 'post',
            body: JSON.stringify(d_imagen)
        })
        .then( res => res.json() )
        .then( function (d) {
            traerEscolaridad()
            // eslint-disable-next-line
            if ( d.codigo == 1 ) {
                elToast( d.mensaje )
                if (tipo === 'cedula' ) {
                    // todo: maneja el archivo_cedula por aparte
                    // otra opción es mandar llamar los nombres de los archivos cuando termina de cargar un archivo
                    // setFormModal({
                    //     ...formModal,
                    //     archivo_cedula: d.nombre_archivo
                    // })
                    // obtenerArchivosTitulado('cedula')
                    setNombreCedula(d.nombre_archivo)
                } else {
                    // setFormModal({
                    //     ...formModal,
                    //     archivo_titulo: d.nombre_archivo
                    // })
                    // obtenerArchivosTitulado('titulo')
                    setNombreTitulo(d.nombre_archivo)
                }
                // cerrarModal()
            } else {
                elToast( d.mensaje, 'error' )
            }
        })
        .catch( a => elToast("Error al guardar información.\nPuedes revisar tu conexión o iniciar sesión nuevamente.", 'error') )
        .finally( () => {
        // eslint-disable-next-line
            if (tipo == 'cedula') {
                    setCargandoCedula(false)
            } else {
                setCargandoTitulo(false)
            }
        })

    }

    function actualizarEscolaridadFormulario() {
        // eslint-disable-next-line
        if (formModal != formModal2) {

            var x = { ...formModal, pk_escolaridad, funcion: 'actualizarEscolaridadFormulario' }
            // return

            setCargando( true )
            fetch( URL, {
                method: 'post',
                body: JSON.stringify(x)
            })
            .then( res => res.json() )
            .then( function (d) {
                traerEscolaridad()
                // eslint-disable-next-line
                if ( d.codigo == 1 ) {
                    elToast( d.mensaje )
                    // cerrarModal()
                } else {
                    elToast( d.mensaje, 'error' )
                }
            })
            .catch( a => elToast("Error al actualizar información.\nPuedes revisar tu conexión o iniciar sesión nuevamente.", 'error') )
            .finally( () => setCargando( false ) )


        }
    }


    useEffect(() => {
        // eslint-disable-next-line
        if ( formModal != {} ) {

            if (pk_escolaridad > 0 && campoEditando === 'es_titulado') {
                actualizarUnSoloCampo(campoEditando, valorEditando, pk_escolaridad)
            }

            return
            // haré pruebas para ya no usar esta madre
            // eslint-disable-next-line
            if (campoEditando == 'cedula' ) {
                const timeoutId = setTimeout(() => {
                    actualizarUnSoloCampo(campoEditando, valorEditando, pk_escolaridad)
                }, 1000);

                // eslint-disable-next-line
                return () => clearTimeout(timeoutId);

                // eslint-disable-next-line
            } else {

                // eslint-disable-next-line
                if (pk_escolaridad > 0 && campoEditando != '' && valorEditando != '' && campoEditando != undefined) {

                    var campos_rapidos = ['es_titulado', 'escolaridad']

                    const timeoutId = setTimeout(() => {
                        actualizarUnSoloCampo(campoEditando, valorEditando, pk_escolaridad)
                    }, campos_rapidos.includes(campoEditando) ? 0 : 1000);

                    // eslint-disable-next-line
                    return () => clearTimeout(timeoutId);

                }
            }
        }
        // eslint-disable-next-line
    }, [ formModal ])


    // useEffects
    useEffect(() => {
        traerEscolaridad()
        // eslint-disable-next-line
    }, [])


    return {
        isOpen, abrirModal, cerrarModal,
        guardarEscolaridad, setFormEscolaridad, formEscolaridad,
        check, traerEscolaridad, escolaridadesUsuario, borrarEscolaridad,
        llenarFormEscolaridad, cargando, procesarArchivo, url_archivos, mostrarInput,
        setMostrarInput, mostrarOcultar, setMostrarOcultar, openEditar, setOpenEditar,
        pk_escolaridad,
        isOpenEditar, setIsOpenEditar, cerrarModalEditar,
        setCampoEditando, setValorEditando, formModal, setFormModal, preguntarTitulacion,
        cargandoActualizar, procesarArchivoEditar, actualizarEscolaridadFormulario,
        cargandoCedula, cargandoTitulo, nombreCedula, nombreTitulo, cargandoCedulaEnlace, cargandoTituloEnlace
    }
}

export default useEscolaridades
